import React from 'react'

import { Accordion } from "/react4xp/shared/accordion/accordion";

export default (props) => <Accordion {...props} />
